export const words = [
  "house",
  "money",
  "grass",
  "development",
  "benevolent",
  "despot",
  "destruction",
  "egregious",
  "absolute",
  "denial",
  "procrastination",
  "outstanding",
  "government",
  "reason",
  "irrational",
  "arbitrary",
  "stoic",
  "storm",
  "building",
  "marvelous",
  "engraving",
  "level",
  "insanity",
  "incediary",
  "combination",
  "consideration",
  "material",
];

export const difficultyLevels = [
  {
    level: "easy",
    points: 1,
    limit: 8,
    color: "text-yellow-200",
  },
  {
    level: "medium",
    points: 2,
    limit: 4,
    color: "text-orange-400",
  },
  {
    level: "hard",
    points: 5,
    limit: 2,
    color: "text-red-500",
  },
];
